import { useApolloClient } from '@apollo/client';
import Button from '@mostrans/web-components/components/base/Button';
import Dropzone from '@mostrans/web-components/components/base/Dropzone';
import FormGroup from '@mostrans/web-components/components/base/FormGroup';
import IconButton from '@mostrans/web-components/components/base/IconButton';
import Input from '@mostrans/web-components/components/base/Input';
import { Dialog, DialogActions, DialogContent, Icon, Link } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import { InsertMediaLandingPage, updateMediaLandingPage } from '../../../../GQL/mutations';
import GlobalLoading from '../../../../shared/GlobalLoading';
import { uploadMediaInformation } from '../../../../shared/firebaseServices';
import { globalLoadingNonScreenAtom } from '../../../../shared/globalStates';
import { errMssgHelper, fileImageValidation, generateFileName, toastError, toastSuccess } from '../../../../shared/helpers';

const Container = styled.div`
    display: grid;
    grid-template-row: 1fr 2fr;
    gap: 2rem;
`;

function ModalCreateInformation({ onClose, open = true, dataDetail }) {
  const [urlFile, setUrlFile] = useState()
  const [filesUpload, setFilesUpload] = useState()
  const [informationDesc, setInformationDesc] = useState("")
  const [errInput, setErrInput] = useState(false)
  const client = useApolloClient()
  const setIsLoading = useSetRecoilState(globalLoadingNonScreenAtom)



  useEffect(() => {
    if (dataDetail) {
      setInformationDesc(dataDetail?.deskripsi)
      setUrlFile(dataDetail?.link_media)
      setFilesUpload("View File")
    } else {
      setInformationDesc("")
      setUrlFile("")
      setFilesUpload("")
    }
  }, [dataDetail, open, onClose])

  const handleUploadMedia = async (file) => {
    if (!fileImageValidation(file.name)) {
      return toastError("NOK: file format not supported.")
    }
    setFilesUpload(file.name)
    const docName = generateFileName("MEDIA-", file.name)
    try {
      setIsLoading(true)
      const url_file = await uploadMediaInformation(file, docName)
      setUrlFile(url_file)
    } catch (error) {
      toastError(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSubmitInformation = async () => {
    const paramInsert = {
      link_media: urlFile,
      deskripsi: informationDesc,
    }
    if (urlFile === "" || informationDesc === "") {
      return setErrInput(true)
    }
    try {
      const result = await InsertMediaLandingPage(client, paramInsert)
      if (result.errMsg === "OK") {
        await toastSuccess("Result Submitted")
        await onClose()
        setUrlFile("")
        setInformationDesc("")
        setFilesUpload("")
      } else {
        toastError(result.errMsg)
      }
    } catch (error) {
      toastError(error)
    }
  }


  const UpdateInformation = async () => {
    const paramInsert = {
      id: dataDetail?.id,
      link_media: urlFile,
      deskripsi: informationDesc
    }


    if (urlFile === "" || informationDesc === "") {
      return setErrInput(true)
    }

    try {
      setIsLoading(true)
      const responUpdate = await updateMediaLandingPage(client, paramInsert);
      // fetchLandingPageAdmin()
      if (responUpdate.errMsg === "OK") {
        await toastSuccess("Information Updated")
        await onClose()
        setUrlFile("")
        setInformationDesc("")
        setFilesUpload("")
        setIsLoading(false)
      } else {
        toastError(responUpdate.data.deleteMasterClinic.errMsg)
      }
    } catch (error) {
      toastError(error);
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <Dialog fullWidth maxWidth="md" onClose={onClose} open={open}>
      <div className="p-1 border-bottom-1 border-outlineSoft justify-content-between d-flex align-items-center">
        <h5>Add New Information</h5>
        <IconButton onClick={onClose}>
          <Icon>close</Icon>
        </IconButton>
      </div>
      <DialogContent>
        <Container>
          <FormGroup
            placement="vertical"
            errorMessage={
              <p style={{ fontSize: 13 }}>Description is required</p>
            }
            isError={errInput && !informationDesc}
            showChildErrorSign
            label={<p style={{ fontSize: 12 }}>Description</p>}
          >
            <Input type="text"
              onChange={(e) => setInformationDesc(e.target.value)}
              defaultValue={dataDetail ? informationDesc : null} />
          </FormGroup>
          <FormGroup
            label={<p style={{ fontSize: "12px" }}>Attachment</p>}
            showChildErrorSign
            errorMessage={errMssgHelper("File attachment is required.")}
            isError={errInput && !urlFile}
          >
            <Dropzone
              topText={<GlobalLoading />}
              onChange={(files) => handleUploadMedia(files[0])}
              middleText={urlFile ?
                <Link href={urlFile} target="_blank" underline="hover">{filesUpload}</Link>
                : "Drag & Drop or Click to Select File"}
              bottomText="Recommended image resolution : 5305 x 1668 Pixel"
            />
          </FormGroup>

        </Container>
      </DialogContent>
      <DialogActions className="gap-50 d-flex p-1 border-top-1 border-outlineSoft">
        <Button
          color="primary"
          variant="outlined">
          Kembali
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={dataDetail ? UpdateInformation : handleSubmitInformation}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalCreateInformation